var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5a4 4 0 11-8 0 4 4 0 018 0zm-.836 3.872a5 5 0 11.707-.707L12 11.292l-.707.707-3.129-3.128z",
    fill: "#A5A7A7"
  })));
}

export default __webpack_public_path__ + "088d0231519c387ffb92b3b632d80024.svg";
export { SvgSearchList as ReactComponent };